import { Block } from "@block";
import { useDesktopMediaQuery } from "@media-query";
import { useNavigation } from "@react-navigation/core";
import { StackActions } from "@react-navigation/routers";
import { spacing } from "@styles/spacing";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import CardHistoryTable, { DataCardHistoryTableProps } from "./filter-table/card-history-table";
import FilterCardHistoryTable, { FormFilterCardHistory } from "./filter-table/card-filter-history-table.web";
import { getCardStoreSelector, getResCardHistorySelector, getStatusCardHistorySelector } from "../reducer/selectors";
import { fetchCardHistoryRequest, setCardStore } from "../reducer/actions";
import { CARDHISTORY } from "app/shared/services/services-model.type";
import { formatNumberThousand } from "app/shared/util/format-currency";
import { formatDate } from "app/shared/util/common";
import { pushAppFlyer } from "app/shared/util/app-flyer";

enum ActionFilter {
  Search,
  Reset,
}

const ListCardHistory = () => {
  const { t } = useTranslation();
  const dispatchStore = useDispatch();
  const { dispatch } = useNavigation();
  const isDesktop = useDesktopMediaQuery();
  const [globalModalRef] = React.useState<React.RefObject<any>>(createGlobalModal());

  const cardStore = useSelector(getCardStoreSelector);
  const listCardHistoryStore = useSelector(getResCardHistorySelector);
  const statusHistory = useSelector(getStatusCardHistorySelector);

  const [isShowTable, setShowTable] = React.useState<boolean>(false);
  const [isSearch, setIsSearch] = React.useState<boolean>(false);
  const [dataList, setDataList] = React.useState<DataCardHistoryTableProps[]>([]);
  const [dataSelect, setDataSelect] = React.useState<FormFilterCardHistory | undefined>();
  // Show modal detail 360 transaction

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const goManager = () => {
    dispatch(StackActions.replace(ScreenNameType.LIST_CARDS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("CARD_DICH_VU_THE"),
      onPressSubtitle: () => goManager(),
    },
    {
      name: t("CARD_LICH_SU_GIAO_DICH"),
      onPressSubtitle: () => {},
    },
  ];

  const requestSearch = (data: FormFilterCardHistory) => {
    dispatchStore(fetchCardHistoryRequest({ cardID: data.cardID, fromDate: data.fromDate, toDate: data.toDate }));
  };

  /**
   * Bắt sự kiện với nút lọc
   * @param type
   * @returns void
   */
  const handleOnChange = (type: ActionFilter) => (_values: FormFilterCardHistory) => {
    setDataSelect(_values);
    switch (type) {
      case ActionFilter.Search:
        requestSearch(_values);
        break;
      case ActionFilter.Reset:
        if (isSearch) setIsSearch(false);
        if (isShowTable) setShowTable(false);
        if (listCardHistoryStore) dispatchStore(setCardStore({ ...cardStore, resCardHistory: undefined, statusCardHistory: "init" }));
        setDataList([]);
        break;
      default:
        break;
    }
  };

  const getStatusName = React.useCallback(
    (status?: number) => {
      switch (status) {
        case -1:
          return t("CARD_TRANG_THAI_GD_THANH_CONG");
        case 0:
          return t("CARD_TRANG_THAI_GD_KHONG_THANH_CONG");
        case 258:
          return t("CARD_TRANG_THAI_TK_HET_HAN");
        case 304:
          return t("CARD_TRANG_THAI_TK_KHONG_XAC_DINH");
        default:
          return "";
      }
    },
    [t],
  );

  const getDataTable = React.useCallback(
    (_data?: CARDHISTORY[]): Array<DataCardHistoryTableProps> => {
      if (_data?.length) {
        _data.map((obj: DataCardHistoryTableProps, index: number) => {
          obj.id = String(index + 1);
          obj.CURRENCY_AMOUNT = formatNumberThousand(obj.transAmount);
          obj.FORMAT_TRANS_DATE = formatDate(obj.datetime, "YYYY/MM/DD HH:mm:ss");
          obj.FORMAT_STATUS = getStatusName(obj.status);
          return obj;
        });
        return _data;
      }
      return [];
    },
    [getStatusName],
  );
  const closeModalInput = () => {
    globalModal.hide(globalModalRef);
  };

  const showModalInput = (content: JSX.Element) => {
    globalModal.show(content, globalModalRef);
  };

  const handlerParamsAppFlyer = () => {
    console.log("handlerParamsAppFlyer");
    const param = {
      card_number: dataSelect?.cardNum,
      from_date: dataSelect?.fromDate,
      to_date: dataSelect?.toDate,
    };
    return {
      eventName: "af_inquiry_card",
      params: {
        af_channel: "ib_rb",
        af_inquiry_info: JSON.stringify(param),
      },
    };
  };

  React.useEffect(() => {
    const _data: DataCardHistoryTableProps[] = getDataTable(listCardHistoryStore);
    setDataList(_data);
  }, [getDataTable, listCardHistoryStore]);

  React.useEffect(() => {
    if (statusHistory === "ok" && !isSearch) {
      setIsSearch(true);
    }
  }, [statusHistory, isSearch]);

  React.useEffect(() => {
    if (statusHistory === "ok" && isSearch && !isShowTable) {
      setIsSearch(false);
      setShowTable(true);
    }
  }, [statusHistory, isShowTable, isSearch]);

  React.useEffect(() => {
    if (statusHistory === "ok") {
      const { eventName, params } = handlerParamsAppFlyer();
      pushAppFlyer(eventName, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusHistory]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("CARD_LICH_SU_GIAO_DICH")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <FilterCardHistoryTable
            onChangeSearch={handleOnChange(ActionFilter.Search)}
            showModal={showModalInput}
            closeModal={closeModalInput}
            onReset={handleOnChange(ActionFilter.Reset)}
          />
          <CardHistoryTable onPressRow={() => {}} data={dataList} onChangeData={() => {}} isShow={isShowTable} />
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default ListCardHistory;
